import { clsx } from 'clsx';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
}

export function Card({ children, className, padding = 'md', onClick }: CardProps) {
  return (
    <div
      className={clsx(
        'rounded-xl border transition-all duration-200',
        'bg-white border-gray-200 shadow-sm',
        'dark:bg-slate-800/80 dark:border-slate-700/30 dark:shadow-lg dark:shadow-black/10',
        onClick && 'hover:border-primary-500/30 dark:hover:border-primary-500/40 hover:shadow-md cursor-pointer',
        {
          'p-0': padding === 'none',
          'p-4': padding === 'sm',
          'p-6': padding === 'md',
          'p-8': padding === 'lg',
        },
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}

interface StatCardProps {
  title: string;
  value: string | number;
  change?: number;
  icon?: React.ReactNode;
}

export function StatCard({ title, value, change, icon }: StatCardProps) {
  return (
    <Card>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-sm font-medium text-gray-500 dark:text-slate-400">{title}</p>
          <p className="mt-3 text-3xl font-semibold tracking-tight text-gray-900 dark:text-white">{value}</p>
          {change !== undefined && (
            <p
              className={clsx('mt-1 text-sm', {
                'text-green-600 dark:text-green-400': change > 0,
                'text-red-600 dark:text-red-400': change < 0,
                'text-gray-500 dark:text-slate-400': change === 0,
              })}
            >
              {change > 0 ? '+' : ''}
              {change.toFixed(1)}% from last period
            </p>
          )}
        </div>
        {icon && (
          <div className="p-2.5 bg-slate-100 dark:bg-slate-700/50 rounded-lg text-gray-500 dark:text-slate-400">{icon}</div>
        )}
      </div>
    </Card>
  );
}
